import { render, staticRenderFns } from "./UpdatePassword.vue?vue&type=template&id=0c4ac130"
import script from "./UpdatePassword.vue?vue&type=script&lang=js"
export * from "./UpdatePassword.vue?vue&type=script&lang=js"
import style0 from "./UpdatePassword.vue?vue&type=style&index=0&id=0c4ac130&prod&lang=scss"
import style1 from "./UpdatePassword.vue?vue&type=style&index=1&id=0c4ac130&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports